import React from 'react';
import { Box, Typography } from '@mui/joy';

const StockPageLayout = ({
  error,
  search,
  pagination,
  paginationMobileOnly = false,
  scrollListAlways = false,
  loading,
  children
}) => (
  <Box
    sx={{
      padding: { xs: 1.5, md: 3 },
      flex: scrollListAlways ? 1 : { xs: 1, md: 'none' },
      width: '100%',
      height: scrollListAlways ? '100%' : { xs: '100%', md: 'auto' },
      minHeight: scrollListAlways ? 0 : { xs: 0, md: 'auto' },
      display: 'flex',
      flexDirection: 'column',
      overflow: scrollListAlways ? 'hidden' : { xs: 'hidden', md: 'visible' }
    }}
  >
    <Box
      sx={{
        flexShrink: 0,
        bgcolor: 'background.body',
        zIndex: 10
      }}
    >
      {error && <Box sx={{ mb: 2 }}>{error}</Box>}
      {search}
      {loading ? (
        <Typography sx={{ py: 2 }}>Loading...</Typography>
      ) : (
        pagination && (
          <Box
            sx={{
              mt: 1.5,
              mb: 0,
              borderBottom: { xs: '1px solid', md: 'none' },
              borderColor: 'divider',
              pb: { xs: 1.5, md: 0 },
              display: paginationMobileOnly ? { xs: 'block', md: 'none' } : 'block'
            }}
          >
            {pagination}
          </Box>
        )
      )}
    </Box>

    {!loading && (
      <Box
        sx={{
          flex: scrollListAlways ? 1 : { xs: 1, md: 'none' },
          minHeight: scrollListAlways ? 0 : { xs: 0, md: 'auto' },
          overflowY: scrollListAlways ? 'auto' : { xs: 'auto', md: 'visible' },
          WebkitOverflowScrolling: 'touch',
          pt: { xs: 1.5, md: scrollListAlways ? 1.5 : 0 }
        }}
      >
        {children}
      </Box>
    )}
  </Box>
);

export default StockPageLayout;
